module.exports = __webpack_public_path__ + "mg.svg?1491077425ac44fdd5ca2a301975640e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/mg.svg
// module id = 1238
// module chunks = 0